import React from 'react';
import { Link } from 'react-router-dom';

function AddButton() {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/group/' }}
    >
      Create Group
    </Link>
  );
}

export default AddButton;
